import { render } from "./doc-submitted.vue?vue&type=template&id=d9ef9dce&scoped=true"
import script from "./doc-submitted.vue?vue&type=script&lang=js"
export * from "./doc-submitted.vue?vue&type=script&lang=js"

import "./doc-submitted.vue?vue&type=style&index=0&id=d9ef9dce&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ef9dce"]])

export default __exports__